// 갤러리 페이지 번역
export default {
  page: {
    sectionLabel: '사진 갤러리',
    title: '교회 갤러리',
    description: '우리 교회 공동체의 소중한 순간들과 행사 사진들을 둘러보세요.'
  },
  categories: {
    all: '전체'
  }
};
